import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { supabase } from '../services/api.js';

export const useStreak = () => {
  const { user, profile } = useAuth();
  const [streak, setStreak]   = useState(0);
  const [longest, setLongest] = useState(0);
  const [active, setActive]   = useState(false);

  // Helper to get local YYYY-MM-DD date based on user's timezone
  // This ensures the frontend "today" matches the database "today"
  const getLocalDate = () => {
    const now = new Date();
    const offset = now.getTimezoneOffset() * 60000;
    return new Date(now - offset).toISOString().slice(0, 10);
  };

  // Get the formal timezone string (e.g., "Asia/Ho_Chi_Minh")
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    if (!profile) return;
    setStreak(profile.current_streak  || 0);
    setLongest(profile.longest_streak || 0);
    
    const today = getLocalDate();
    setActive(profile.last_activity_date === today);
  }, [profile]);

  const recordActivity = async () => {
    if (!user) return;
    try {
      // Pass the user_timezone to your new SQL function
      const { error } = await supabase.rpc('update_streak', { 
        user_id: user.id,
        user_timezone: userTimezone 
      });

      if (error) {
        console.error("Streak RPC Error:", error);
        // Fallback: local update if RPC fails
        const today = getLocalDate();
        if (profile?.last_activity_date !== today) {
          setStreak(s => s + 1);
          setActive(true);
        }
        return;
      }

      // Refresh local state from the profile to ensure accuracy
      const { data } = await supabase
        .from('profiles')
        .select('current_streak, longest_streak, last_activity_date')
        .eq('id', user.id)
        .single();

      if (data) {
        setStreak(data.current_streak  || 0);
        setLongest(data.longest_streak || 0);
        const today = getLocalDate();
        setActive(data.last_activity_date === today);
      }
    } catch (err) {
      console.error("Streak recordActivity caught error:", err);
    }
  };

  return { streak, longest, active, recordActivity };
};

export default useStreak;